'use client';

import { ToastContainer } from '@brahma/components';
const ToastContainerWrapper = (props: any) => {
  return <ToastContainer {...props} data-sentry-element="ToastContainer" data-sentry-component="ToastContainerWrapper" data-sentry-source-file="index.tsx" />;
};
export default ToastContainerWrapper;